
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 57.66V34.2C1.5 17.94 14.26 4.77 30 4.77S58.5 17.94 58.5 34.2v23.46","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M49.75 45.86l-.05 10.8H10.25v-10.8h39.5zM25.5 24.73v-5.78h9v5.84M47.65 24.99l-6.05 9.18H18.25l-5.9-9.03M25.5 34.71v11.22M34.5 34.71v11.22M3.41 25.05h53.18"}})])
          )
        }
      }
    